import { isDefinedString, isPositiveNumber } from "et3-type-guards";
import { memoize } from "lodash";
import getKhattabatStore from "..";
import { apiCallCreateOneOTwo } from "../../../api/khattbat-api/api-call-create-one-o-two";
import getCorePopUpStore from "../../core/core-popup-store";
import getKhattabat101CStore from "../101c-stores";
import { observable, runInAction } from "mobx";
import getKhattabat102Store from ".";
import getCoreUIStore from "../../core/core-ui-store";
import { apiCallReactivateOneOTwo } from "../../../api/khattbat-api/api-call-reactivate-one-o-two";
import getKhattabat102MessagingStore from "../messaging-stores/102-messaging-store";

class Khattabat102GeneralStore {
  reactivateOneOTwoConversationID = observable.box<string>("");
  // Identifies the message shown in the Histories popup. Only the
  // identifying pair is stored; the popup resolves the actual metadata from
  // Khattabat102Store on demand so nothing is duplicated here.
  selectedHistoryConversationID = observable.box<string>("");
  selectedHistoryMessageId = observable.box<number>(0);

  setReactivateOneOTwoConversation = (conversationID: string) => {
    runInAction(() => {
      this.reactivateOneOTwoConversationID.set(conversationID);
    });
  };

  getSelectedHistoryConversationID = (): string => {
    return this.selectedHistoryConversationID.get();
  };

  getSelectedHistoryMessageId = (): number => {
    return this.selectedHistoryMessageId.get();
  };

  openMessageHistoriesPopUp = ({
    conversationID,
    messageId
  }: {
    conversationID: string;
    messageId: number;
  }): void => {
    runInAction(() => {
      this.selectedHistoryConversationID.set(conversationID);
      this.selectedHistoryMessageId.set(messageId);
    });
    getCorePopUpStore().openConfirmationPopUps(
      "KHATTABAT_ONE_O_TWO_MESSAGE_HISTORIES_POPUP"
    );
  };
  createOneOTwo = async (userID: number) => {
    const { userUUID, insertUserIdField } = getKhattabat101CStore(userID);
    const alkhattabaUUID = getKhattabatStore().alkhattabaUUID.get();
    if (!isDefinedString(alkhattabaUUID) || !isDefinedString(userUUID.get())) {
      return;
    }
    const { status, code } = await apiCallCreateOneOTwo({ userID });
    if (status === "OK") {
      insertUserIdField.set(0);
      getKhattabatStore().getClientConversation({ userID, shouldLoad: true });
    } else {
      getCorePopUpStore().showAlertMessage(code);
    }
  };

  reativateOneOTwoConversation = async () => {
    const conversationID = this.reactivateOneOTwoConversationID.get();
    if (!isDefinedString(conversationID)) {
      return;
    }
    getCoreUIStore().setIsLoading("KHATTABAT_CLIENTS", true);
    const { status, code } = await apiCallReactivateOneOTwo({
      oneOTwoConversationID: conversationID
    });
    getCoreUIStore().setIsLoading("KHATTABAT_CLIENTS", false);
    if (status === "OK") {
      const userID =
        getKhattabat102MessagingStore(conversationID).clientReceiverID.get();
      await getKhattabatStore().getClientConversation({
        userID,
        shouldLoad: true
      });
    } else {
      getCorePopUpStore().showAlertMessage(code);
    }
  };

  handleClientIsAlmostExpiredAndNo102QualityUpdate = ({
    clientID
  }: {
    clientID: number;
  }) => {
    const isAlmostExpiredUser =
      getKhattabat101CStore(clientID).vipKhattabaStatus.get() ===
      "ALMOST_EXPIRED";
    if (!isAlmostExpiredUser) {
      return;
    }
    const atLeastOneOneOTwoQualityHasLeft = getKhattabat101CStore(clientID)
      .oneOTwoConversationIds.get()
      .some((oneOTwoConversationId) =>
        isPositiveNumber(
          getKhattabat102Store(oneOTwoConversationId).manualIsQuality.get()
        )
      );

    getKhattabat101CStore(clientID).updateBreachLevelStat({
      booleanKey: "clientIsAlmostExpiredAndNo102Quality",
      booleanKeyNewValue: !atLeastOneOneOTwoQualityHasLeft
    });
  };
}

export const getKhattabat102GeneralStore = memoize(
  () => new Khattabat102GeneralStore(),
  () => 1
);
export default getKhattabat102GeneralStore;
